import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach tokens based on role scope requested by caller.
api.interceptors.request.use((config) => {
  const scope = config.headers?.["X-Auth-Scope"];
  let token = null;
  if (scope === "admin") token = localStorage.getItem("cct_admin_token");
  else if (scope === "recruiter") token = localStorage.getItem("cct_recruiter_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.headers) delete config.headers["X-Auth-Scope"];
  return config;
});

export const adminReq = (cfg = {}) => ({
  ...cfg,
  headers: { ...(cfg.headers || {}), "X-Auth-Scope": "admin" },
});

export const recruiterReq = (cfg = {}) => ({
  ...cfg,
  headers: { ...(cfg.headers || {}), "X-Auth-Scope": "recruiter" },
});

export default api;
